import { render } from "./SnoreLevel.vue?vue&type=template&id=20e9610c&scoped=true&ts=true"
import script from "./SnoreLevel.vue?vue&type=script&lang=ts"
export * from "./SnoreLevel.vue?vue&type=script&lang=ts"

import "./SnoreLevel.vue?vue&type=style&index=0&id=20e9610c&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e9610c"]])

export default __exports__